import type { SurveyAnswer } from '@/data-access/surveys/types'
import { getPollOptions } from './getPollsOptions'

/**
 * Returns the option with the highest number of votes. Will return the first option if there are no votes.
 */
export function getHighestVotedOption(answers: SurveyAnswer[]) {
	const options = getPollOptions(answers)

	return options.reduce((max, option) => (option.tokens > max.tokens ? option : max), options[0])
}
